"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7423],{

/***/ 78385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Portal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22760);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54895);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25091);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
'use client';






function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}

/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */
const Portal = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Portal(props, forwardedRef) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  // @ts-expect-error TODO upstream fix
  const handleRef = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) ? children.ref : null, forwardedRef);
  (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(() => {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(() => {
    if (mountNode && !disablePortal) {
      (0,_mui_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(forwardedRef, mountNode);
      return () => {
        (0,_mui_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(forwardedRef, null);
      };
    }
    return undefined;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children)) {
      const newProps = {
        ref: handleRef
      };
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, newProps);
    }
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: mountNode ? /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, mountNode) : mountNode
  });
});
 false ? 0 : void 0;
if (false) {}


/***/ }),

/***/ 84808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Backdrop_Backdrop; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1977);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(8027);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Backdrop/backdropClasses.js


function getBackdropUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiBackdrop', slot);
}
const backdropClasses = (0,generateUtilityClasses/* default */.Z)('MuiBackdrop', ['root', 'invisible']);
/* harmony default export */ var Backdrop_backdropClasses = ((/* unused pure expression or super */ null && (backdropClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js
'use client';



const _excluded = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ['root', invisible && 'invisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getBackdropUtilityClass, classes);
};
const BackdropRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent'
}, ownerState.invisible && {
  backgroundColor: 'transparent'
}));
const Backdrop = /*#__PURE__*/react.forwardRef(function Backdrop(inProps, ref) {
  var _slotProps$root, _ref, _slots$root;
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiBackdrop'
  });
  const {
      children,
      className,
      component = 'div',
      components = {},
      componentsProps = {},
      invisible = false,
      open,
      slotProps = {},
      slots = {},
      TransitionComponent = Fade/* default */.Z,
      transitionDuration
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    invisible
  });
  const classes = useUtilityClasses(ownerState);
  const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropRoot, (0,esm_extends/* default */.Z)({
      "aria-hidden": true
    }, rootSlotProps, {
      as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
      className: (0,clsx/* default */.Z)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
      ownerState: (0,esm_extends/* default */.Z)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
      classes: classes,
      ref: ref,
      children: children
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Backdrop_Backdrop = (Backdrop);

/***/ }),

/***/ 16628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8662);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30577);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51705);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








const styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};

/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Fade = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Fade(props, ref) {
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);
  const enableStrictModeCompat = true;
  const nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .reflow */ .n)(node); // So the animation always start from the start.

    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    appear: appear,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Fade);

/***/ }),

/***/ 25454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js
var useSlotProps = __webpack_require__(7293);
// EXTERNAL MODULE: ./node_modules/@mui/utils/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(22760);
// EXTERNAL MODULE: ./node_modules/@mui/utils/ownerDocument/ownerDocument.js
var ownerDocument = __webpack_require__(36425);
// EXTERNAL MODULE: ./node_modules/@mui/utils/useEventCallback/useEventCallback.js
var useEventCallback = __webpack_require__(22010);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/createChainedFunction/createChainedFunction.js
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/extractEventHandlers.js
var extractEventHandlers = __webpack_require__(30437);
// EXTERNAL MODULE: ./node_modules/@mui/utils/ownerWindow/ownerWindow.js
var ownerWindow = __webpack_require__(96613);
// EXTERNAL MODULE: ./node_modules/@mui/utils/getScrollbarSize/getScrollbarSize.js
var getScrollbarSize = __webpack_require__(98902);
;// CONCATENATED MODULE: ./node_modules/@mui/base/unstable_useModal/ModalManager.js

// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  const doc = (0,ownerDocument/* default */.Z)(container);
  if (doc.body === container) {
    return (0,ownerWindow/* default */.Z)(container).innerWidth > doc.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}
function getPaddingRight(element) {
  return parseInt((0,ownerWindow/* default */.Z)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
  // The forbidden HTML tags are the ones from ARIA specification that
  // can be children of body and can't have aria-hidden attribute.
  // cf. https://www.w3.org/TR/html-aria/#docconformance
  const forbiddenTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE', 'LINK', 'MAP', 'META', 'NOSCRIPT', 'PICTURE', 'COL', 'COLGROUP', 'PARAM', 'SLOT', 'SOURCE', 'TRACK'];
  const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
  const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
  return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  [].forEach.call(container.children, element => {
    const isNotExcludedElement = blacklist.indexOf(element) === -1;
    const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, show);
    }
  });
}
function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index) => {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}
function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;
  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      const scrollbarSize = (0,getScrollbarSize/* default */.Z)((0,ownerDocument/* default */.Z)(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      });
      // Use computed style, here to get the real padding to add our scrollbar width.
      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;

      // .mui-fixed is a global helper.
      const fixedElements = (0,ownerDocument/* default */.Z)(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, element => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    }
    let scrollContainer;
    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = (0,ownerDocument/* default */.Z)(container).body;
    } else {
      // Support html overflow-y: auto for scroll stability between pages
      // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
      const parent = container.parentElement;
      const containerWindow = (0,ownerWindow/* default */.Z)(container);
      scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
    }

    // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }
  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };
  return restore;
}
function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, element => {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }
  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);
    if (modalIndex !== -1) {
      return modalIndex;
    }
    modalIndex = this.modals.length;
    this.modals.push(modal);

    // If the modal we are adding is already in the DOM.
    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }
    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, item => item.container === container);
    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }
    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }
  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }
  remove(modal, ariaHiddenState = true) {
    const modalIndex = this.modals.indexOf(modal);
    if (modalIndex === -1) {
      return modalIndex;
    }
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1);

    // If that was the last modal in a container, clean up the container.
    if (containerInfo.modals.length === 0) {
      // The modal might be closed before it had the chance to be mounted in the DOM.
      if (containerInfo.restore) {
        containerInfo.restore();
      }
      if (modal.modalRef) {
        // In case the modal wasn't in the DOM yet.
        ariaHidden(modal.modalRef, ariaHiddenState);
      }
      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      // Otherwise make sure the next top modal is visible to a screen reader.
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
      // as soon as a modal is adding its modalRef is undefined. it can't set
      // aria-hidden because the dom element doesn't exist either
      // when modal was unmounted before modalRef gets null
      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }
    return modalIndex;
  }
  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/unstable_useModal/useModal.js
'use client';






function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
function getHasTransition(children) {
  return children ? children.props.hasOwnProperty('in') : false;
}

// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const defaultManager = new ModalManager();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */
function useModal(parameters) {
  const {
    container,
    disableEscapeKeyDown = false,
    disableScrollLock = false,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = defaultManager,
    closeAfterTransition = false,
    onTransitionEnter,
    onTransitionExited,
    children,
    onClose,
    open,
    rootRef
  } = parameters;

  // @ts-ignore internal logic
  const modal = react.useRef({});
  const mountNodeRef = react.useRef(null);
  const modalRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(modalRef, rootRef);
  const [exited, setExited] = react.useState(!open);
  const hasTransition = getHasTransition(children);
  let ariaHiddenProp = true;
  if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) {
    ariaHiddenProp = false;
  }
  const getDoc = () => (0,ownerDocument/* default */.Z)(mountNodeRef.current);
  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mount = mountNodeRef.current;
    return modal.current;
  };
  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    });

    // Fix a bug on Chrome where the scroll isn't initially 0.
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  };
  const handleOpen = (0,useEventCallback/* default */.Z)(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer);

    // The element was already mounted.
    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = react.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = (0,useEventCallback/* default */.Z)(node => {
    mountNodeRef.current = node;
    if (!node) {
      return;
    }
    if (open && isTopModal()) {
      handleMounted();
    } else if (modalRef.current) {
      ariaHidden(modalRef.current, ariaHiddenProp);
    }
  });
  const handleClose = react.useCallback(() => {
    manager.remove(getModal(), ariaHiddenProp);
  }, [ariaHiddenProp, manager]);
  react.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  react.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
  const createHandleKeyDown = otherHandlers => event => {
    var _otherHandlers$onKeyD;
    (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);

    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || event.which === 229 ||
    // Wait until IME is settled.
    !isTopModal()) {
      return;
    }
    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();
      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };
  const createHandleBackdropClick = otherHandlers => event => {
    var _otherHandlers$onClic;
    (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
    if (event.target !== event.currentTarget) {
      return;
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const getRootProps = (otherHandlers = {}) => {
    const propsEventHandlers = (0,extractEventHandlers/* extractEventHandlers */._)(parameters);

    // The custom event handlers shouldn't be spread on the root element
    delete propsEventHandlers.onTransitionEnter;
    delete propsEventHandlers.onTransitionExited;
    const externalEventHandlers = (0,esm_extends/* default */.Z)({}, propsEventHandlers, otherHandlers);
    return (0,esm_extends/* default */.Z)({
      role: 'presentation'
    }, externalEventHandlers, {
      onKeyDown: createHandleKeyDown(externalEventHandlers),
      ref: handleRef
    });
  };
  const getBackdropProps = (otherHandlers = {}) => {
    const externalEventHandlers = otherHandlers;
    return (0,esm_extends/* default */.Z)({
      'aria-hidden': true
    }, externalEventHandlers, {
      onClick: createHandleBackdropClick(externalEventHandlers),
      open
    });
  };
  const getTransitionProps = () => {
    const handleEnter = () => {
      setExited(false);
      if (onTransitionEnter) {
        onTransitionEnter();
      }
    };
    const handleExited = () => {
      setExited(true);
      if (onTransitionExited) {
        onTransitionExited();
      }
      if (closeAfterTransition) {
        handleClose();
      }
    };
    return {
      onEnter: createChainedFunction(handleEnter, children == null ? void 0 : children.props.onEnter),
      onExited: createChainedFunction(handleExited, children == null ? void 0 : children.props.onExited)
    };
  };
  return {
    getRootProps,
    getBackdropProps,
    getTransitionProps,
    rootRef: handleRef,
    portalRef: handlePortalRef,
    isTopModal,
    exited,
    hasTransition
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/base/FocusTrap/FocusTrap.js
'use client';

/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */





// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');
function getTabIndex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  }

  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.
  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }
  return node.tabIndex;
}
function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }
  if (!node.name) {
    return false;
  }
  const getRadio = selector => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
  let roving = getRadio(`[name="${node.name}"]:checked`);
  if (!roving) {
    roving = getRadio(`[name="${node.name}"]`);
  }
  return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }
  return true;
}
function defaultGetTabbable(root) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
    const nodeTabIndex = getTabIndex(node);
    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }
    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node: node
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map(a => a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
  return true;
}

/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */
function FocusTrap(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = react.useRef(false);
  const sentinelStart = react.useRef(null);
  const sentinelEnd = react.useRef(null);
  const nodeToRestore = react.useRef(null);
  const reactFocusEventTarget = react.useRef(null);
  // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.
  const activated = react.useRef(false);
  const rootRef = react.useRef(null);
  // @ts-expect-error TODO upstream fix
  const handleRef = (0,useForkRef/* default */.Z)(children.ref, rootRef);
  const lastKeydown = react.useRef(null);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    const doc = (0,ownerDocument/* default */.Z)(rootRef.current);
    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {}
        rootRef.current.setAttribute('tabIndex', '-1');
      }
      if (activated.current) {
        rootRef.current.focus();
      }
    }
    return () => {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }
        nodeToRestore.current = null;
      }
    };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    const doc = (0,ownerDocument/* default */.Z)(rootRef.current);
    const loopFocus = nativeEvent => {
      lastKeydown.current = nativeEvent;
      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      }

      // Make sure the next tab starts from the right place.
      // doc.activeElement refers to the origin.
      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        if (sentinelEnd.current) {
          sentinelEnd.current.focus();
        }
      }
    };
    const contain = () => {
      const rootElement = rootRef.current;

      // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.
      if (rootElement === null) {
        return;
      }
      if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      // The focus is already inside
      if (rootElement.contains(doc.activeElement)) {
        return;
      }

      // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
      if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) {
        return;
      }

      // if the focus event is not coming from inside the children's react tree, reset the refs
      if (doc.activeElement !== reactFocusEventTarget.current) {
        reactFocusEventTarget.current = null;
      } else if (reactFocusEventTarget.current !== null) {
        return;
      }
      if (!activated.current) {
        return;
      }
      let tabbable = [];
      if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
        tabbable = getTabbable(rootRef.current);
      }

      // one of the sentinel nodes was focused, so move the focus
      // to the first/last tabbable element inside the focus trap
      if (tabbable.length > 0) {
        var _lastKeydown$current, _lastKeydown$current2;
        const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
        const focusNext = tabbable[0];
        const focusPrevious = tabbable[tabbable.length - 1];
        if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        }
        // no tabbable elements in the trap focus or the focus was outside of the focus trap
      } else {
        rootElement.focus();
      }
    };
    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true);

    // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
    const interval = setInterval(() => {
      if (doc.activeElement && doc.activeElement.tagName === 'BODY') {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);
  const onFocus = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const handleFocusSentinel = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /*#__PURE__*/react.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}
 false ? 0 : void 0;
if (false) {}

// EXTERNAL MODULE: ./node_modules/@mui/base/Portal/Portal.js
var Portal = __webpack_require__(78385);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(84808);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1977);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(8027);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Modal/modalClasses.js


function getModalUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiModal', slot);
}
const modalClasses = (0,generateUtilityClasses/* default */.Z)('MuiModal', ['root', 'hidden', 'backdrop']);
/* harmony default export */ var Modal_modalClasses = ((/* unused pure expression or super */ null && (modalClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/Modal/Modal.js
'use client';



const _excluded = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"];
















const useUtilityClasses = ownerState => {
  const {
    open,
    exited,
    classes
  } = ownerState;
  const slots = {
    root: ['root', !open && exited && 'hidden'],
    backdrop: ['backdrop']
  };
  return (0,composeClasses/* default */.Z)(slots, getModalUtilityClass, classes);
};
const ModalRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  zIndex: (theme.vars || theme).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !ownerState.open && ownerState.exited && {
  visibility: 'hidden'
}));
const ModalBackdrop = (0,styled/* default */.ZP)(Backdrop/* default */.Z, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  }
})({
  zIndex: -1
});

/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
const Modal = /*#__PURE__*/react.forwardRef(function Modal(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    name: 'MuiModal',
    props: inProps
  });
  const {
      BackdropComponent = ModalBackdrop,
      BackdropProps,
      className,
      closeAfterTransition = false,
      children,
      container,
      component,
      components = {},
      componentsProps = {},
      disableAutoFocus = false,
      disableEnforceFocus = false,
      disableEscapeKeyDown = false,
      disablePortal = false,
      disableRestoreFocus = false,
      disableScrollLock = false,
      hideBackdrop = false,
      keepMounted = false,
      onBackdropClick,
      open,
      slotProps,
      slots
      // eslint-disable-next-line react/prop-types
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const propsWithDefaults = (0,esm_extends/* default */.Z)({}, props, {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  });
  const {
    getRootProps,
    getBackdropProps,
    getTransitionProps,
    portalRef,
    isTopModal,
    exited,
    hasTransition
  } = useModal((0,esm_extends/* default */.Z)({}, propsWithDefaults, {
    rootRef: ref
  }));
  const ownerState = (0,esm_extends/* default */.Z)({}, propsWithDefaults, {
    exited
  });
  const classes = useUtilityClasses(ownerState);
  const childProps = {};
  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  }

  // It's a Transition like component
  if (hasTransition) {
    const {
      onEnter,
      onExited
    } = getTransitionProps();
    childProps.onEnter = onEnter;
    childProps.onExited = onExited;
  }
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
  const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
  const rootProps = (0,useSlotProps/* useSlotProps */.y)({
    elementType: RootSlot,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    getSlotProps: getRootProps,
    additionalProps: {
      ref,
      as: component
    },
    ownerState,
    className: (0,clsx/* default */.Z)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
  });
  const backdropProps = (0,useSlotProps/* useSlotProps */.y)({
    elementType: BackdropSlot,
    externalSlotProps: backdropSlotProps,
    additionalProps: BackdropProps,
    getSlotProps: otherHandlers => {
      return getBackdropProps((0,esm_extends/* default */.Z)({}, otherHandlers, {
        onClick: e => {
          if (onBackdropClick) {
            onBackdropClick(e);
          }
          if (otherHandlers != null && otherHandlers.onClick) {
            otherHandlers.onClick(e);
          }
        }
      }));
    },
    className: (0,clsx/* default */.Z)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
    ownerState
  });
  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Portal/* Portal */.h, {
    ref: portalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(RootSlot, (0,esm_extends/* default */.Z)({}, rootProps, {
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropSlot, (0,esm_extends/* default */.Z)({}, backdropProps)) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(FocusTrap, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/react.cloneElement(children, childProps)
      })]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_Modal = (Modal);

/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paper_Paper; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/getOverlayAlpha.js
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const getOverlayAlpha = elevation => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
/* harmony default export */ var styles_getOverlayAlpha = (getOverlayAlpha);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1977);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(8027);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/paperClasses.js


function getPaperUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiPaper', slot);
}
const paperClasses = (0,generateUtilityClasses/* default */.Z)('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
/* harmony default export */ var Paper_paperClasses = ((/* unused pure expression or super */ null && (paperClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/Paper.js
'use client';



const _excluded = ["className", "component", "elevation", "square", "variant"];













const useUtilityClasses = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getPaperUtilityClass, classes);
};
const PaperRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return (0,esm_extends/* default */.Z)({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && (0,esm_extends/* default */.Z)({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))}, ${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /*#__PURE__*/react.forwardRef(function Paper(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiPaper'
  });
  const {
      className,
      component = 'div',
      elevation = 1,
      square = false,
      variant = 'elevation'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    elevation,
    square,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  if (false) {}
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PaperRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Paper_Paper = (Paper);

/***/ }),

/***/ 30577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getTransitionProps; },
/* harmony export */   "n": function() { return /* binding */ reflow; }
/* harmony export */ });
const reflow = node => node.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;
  const {
    timeout,
    easing,
    style = {}
  } = props;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}

/***/ }),

/***/ 98902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getScrollbarSize; }
/* harmony export */ });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}

/***/ }),

/***/ 8662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 43430:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HomePayVisitorHeader_HomePayVisitorHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/hooks/useIsCare24Theme.js
var useIsCare24Theme = __webpack_require__(39986);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/RtlProvider/index.js
var RtlProvider = __webpack_require__(82056);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(25454);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(8662);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/transitions/utils.js
var utils = __webpack_require__(30577);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerWindow.js
var ownerWindow = __webpack_require__(5340);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Slide/Slide.js
'use client';



const _excluded = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];












// Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.

function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = (0,ownerWindow/* default */.Z)(node);
  let transform;
  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }
  let offsetX = 0;
  let offsetY = 0;
  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }
  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }
    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }
  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }
    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }
  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }
    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  }

  // direction === 'down'
  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }
  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);
  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}

/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Slide = /*#__PURE__*/react.forwardRef(function Slide(props, ref) {
  const theme = (0,useTheme/* default */.Z)();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      container: containerProp,
      direction = 'down',
      easing: easingProp = defaultEasing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Transition/* default */.ZP
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const childrenRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(children.ref, childrenRef, ref);
  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    (0,utils/* reflow */.n)(node);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = (0,utils/* getTransitionProps */.C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0,esm_extends/* default */.Z)({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', (0,esm_extends/* default */.Z)({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,utils/* getTransitionProps */.C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';
    if (onExited) {
      onExited(node);
    }
  });
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };
  const updatePosition = react.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  react.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }
    const handleResize = (0,debounce/* default */.Z)(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = (0,ownerWindow/* default */.Z)(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  react.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react.cloneElement(children, (0,esm_extends/* default */.Z)({
        ref: handleRef,
        style: (0,esm_extends/* default */.Z)({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Slide_Slide = (Slide);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/rootShouldForwardProp.js
var rootShouldForwardProp = __webpack_require__(14136);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1977);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(8027);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Drawer/drawerClasses.js


function getDrawerUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiDrawer', slot);
}
const drawerClasses = (0,generateUtilityClasses/* default */.Z)('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);
/* harmony default export */ var Drawer_drawerClasses = ((/* unused pure expression or super */ null && (drawerClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/Drawer/Drawer.js
'use client';



const Drawer_excluded = ["BackdropProps"],
  _excluded2 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];















const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};
const useUtilityClasses = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${(0,capitalize/* default */.Z)(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${(0,capitalize/* default */.Z)(anchor)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getDrawerUtilityClass, classes);
};
const DrawerRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.drawer
}));
const DrawerDockedRoot = (0,styled/* default */.ZP)('div', {
  shouldForwardProp: rootShouldForwardProp/* default */.Z,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver
})({
  flex: '0 0 auto'
});
const DrawerPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${(0,capitalize/* default */.Z)(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0,capitalize/* default */.Z)(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: (theme.vars || theme).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor({
  direction
}, anchor) {
  return direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}

/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */
const Drawer = /*#__PURE__*/react.forwardRef(function Drawer(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiDrawer'
  });
  const theme = (0,useTheme/* default */.Z)();
  const isRtl = (0,RtlProvider/* useRtl */.V)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      anchor: anchorProp = 'left',
      BackdropProps,
      children,
      className,
      elevation = 16,
      hideBackdrop = false,
      ModalProps: {
        BackdropProps: BackdropPropsProp
      } = {},
      onClose,
      open = false,
      PaperProps = {},
      SlideProps,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Slide_Slide,
      transitionDuration = defaultTransitionDuration,
      variant = 'temporary'
    } = props,
    ModalProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.ModalProps, Drawer_excluded),
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

  // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.
  const mounted = react.useRef(false);
  react.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor({
    direction: isRtl ? 'rtl' : 'ltr'
  }, anchorProp);
  const anchor = anchorProp;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);
  const classes = useUtilityClasses(ownerState);
  const drawer = /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerPaper, (0,esm_extends/* default */.Z)({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: (0,clsx/* default */.Z)(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));
  if (variant === 'permanent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }
  const slidingDrawer = /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));
  if (variant === 'persistent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  }

  // variant === temporary
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerRoot, (0,esm_extends/* default */.Z)({
    BackdropProps: (0,esm_extends/* default */.Z)({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: (0,clsx/* default */.Z)(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Drawer_Drawer = (Drawer);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityClose.js
var Icon24UtilityClose = __webpack_require__(82843);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronLeft.js
var Icon24UtilityChevronLeft = __webpack_require__(12330);
// EXTERNAL MODULE: ./node_modules/@care/react-svg-icons/dist/Icon24Close.js
var Icon24Close = __webpack_require__(31442);
// EXTERNAL MODULE: ./node_modules/@care/react-svg-icons/dist/Icon24ChevronLeft.js
var Icon24ChevronLeft = __webpack_require__(18115);
;// CONCATENATED MODULE: ./node_modules/@care/react-component-lib/dist/components/Drawer/Drawer.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





/**
 * A drawer that slides in from the determined edge of the screen.
 * Their blocking behavior makes them suitable for menus.
 *
 * Expands on Material UI's Drawer component with Care specific styling.
 * @see {@link https://v5.mui.com/pt/api/drawer/ Material UI | Drawer}
 */
const Drawer_Drawer_Drawer = (_a) => {
    var { onClose, onBack, PaperProps, hideCloseButton, drawerTitle, children, anchor, elevation = 4 } = _a, rest = __rest(_a, ["onClose", "onBack", "PaperProps", "hideCloseButton", "drawerTitle", "children", "anchor", "elevation"]);
    const isCare24 = (0,useIsCare24Theme/* default */.Z)();
    const { spacing, palette } = (0,useTheme/* default */.Z)();
    const isSideDrawer = anchor === 'left' || anchor === 'right';
    const IconClose = isCare24 ? Icon24Close/* default */.Z : Icon24UtilityClose/* default */.Z;
    const IconChevronLeft = isCare24 ? Icon24ChevronLeft/* default */.Z : Icon24UtilityChevronLeft/* default */.Z;
    const handleClose = (event) => onClose === null || onClose === void 0 ? void 0 : onClose(event, 'backdropClick');
    return (react.createElement(Drawer_Drawer, Object.assign({ elevation: elevation, onClose: handleClose, anchor: anchor, PaperProps: Object.assign(Object.assign({}, PaperProps), { sx: [
                {
                    minWidth: isSideDrawer ? { xs: '100%', sm: '340px' } : undefined,
                    maxWidth: isSideDrawer ? { xs: '100%', sm: '600px', md: '60%' } : undefined,
                    maxHeight: isSideDrawer ? undefined : '95%',
                    p: isSideDrawer ? spacing(0, 0, 2, 0) : 0,
                    boxShadow: isSideDrawer ? '0 0 16px rgba(0, 0, 0, 0.25)' : undefined,
                },
                ...(Array.isArray(PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.sx) ? PaperProps.sx : [PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.sx]),
            ] }) }, rest),
        react.createElement(Box/* default */.Z, { sx: {
                alignItems: 'center',
                display: 'flex',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                minHeight: spacing(6),
                padding: spacing(0, 2),
            } },
            onBack && (react.createElement(IconButton/* default */.Z, { "aria-label": "Back", size: "small", onClick: onBack },
                react.createElement(IconChevronLeft, { "aria-label": "back icon", size: "20px" }))),
            drawerTitle &&
                (typeof drawerTitle === 'string' ? (react.createElement(Typography/* default */.Z, { variant: "h3", className: "label" }, drawerTitle)) : (drawerTitle)),
            !hideCloseButton && (react.createElement(IconButton/* default */.Z, { sx: [
                    !drawerTitle && {
                        marginLeft: 'auto', // forces the 'x' all the way to the right when there is no other content
                    },
                ], onClick: handleClose, size: "small" },
                react.createElement(IconClose, { "aria-label": "Close", color: palette.icon.primary })))),
        react.createElement(Box/* default */.Z, { sx: {
                overflowY: 'auto',
                pb: isSideDrawer ? undefined : 2,
            } }, children)));
};
/**
 * A drawer that slides in from the side of the screen.
 * Primarily used on mobile, a user must interact with or dismiss the drawer before continuing.
 * Their blocking behavior makes them suitable for menus.
 *
 * Expands on Material UI's Drawer component with Care specific styling.
 * @see {@link https://v5.mui.com/pt/api/drawer/ Material UI | Drawer}
 */
const SideDrawer = (_a) => {
    var { anchor = 'left', label, drawerTitle } = _a, rest = __rest(_a, ["anchor", "label", "drawerTitle"]);
    return (react.createElement(Drawer_Drawer_Drawer, Object.assign({ anchor: anchor, drawerTitle: drawerTitle !== null && drawerTitle !== void 0 ? drawerTitle : label }, rest)));
};
/**
 * BottomDrawer are surfaces containing supplementary content that are
 * anchored to the bottom of the screen Action Sheets are supplementary
 * surfaces primarily used on mobile. The user must interact with or
 * dismiss an Action Sheet Their blocking behavior make them suitable
 * for menus. There is a wrapper around the content with an
 * `overflow-y: auto;` to allow the content to scroll up and down while
 * keeping the label and close icon visible To limit the size of the
 * drawer, you can set a \`max-height\` on the child to prevent it from
 * filling the entire screen.
 */
const BottomDrawer = (_a) => {
    var { drawerTitle, label } = _a, rest = __rest(_a, ["drawerTitle", "label"]);
    return (React.createElement(Drawer_Drawer_Drawer, Object.assign({ anchor: "bottom", drawerTitle: drawerTitle !== null && drawerTitle !== void 0 ? drawerTitle : label }, rest)));
};
/* harmony default export */ var components_Drawer_Drawer = ((/* unused pure expression or super */ null && (Drawer_Drawer_Drawer)));
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityMenu.js
var Icon24UtilityMenu = __webpack_require__(94215);
// EXTERNAL MODULE: ./node_modules/@care/react-svg-icons/dist/Icon24Menu.js
var Icon24Menu = __webpack_require__(38881);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Logo/Logo.js + 1 modules
var Logo = __webpack_require__(4859);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconLogoHomepaylogo.js
var IconLogoHomepaylogo = __webpack_require__(20074);
;// CONCATENATED MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorHeader/components/BrandLink.js
var BrandLink_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const BrandLink = (_a) => {
    var _b;
    var { branding, altLogoUrl } = _a, rest = BrandLink_rest(_a, ["branding", "altLogoUrl"]);
    return (react.createElement(Link/* default */.Z, Object.assign({ "data-testid": "header-brand-link", href: branding.href, sx: {
            display: 'inline-flex',
            '& > span.MuiTypography-root': {
                display: 'flex',
            },
        }, underline: "none" }, rest), (_b = branding.logo) !== null && _b !== void 0 ? _b : (altLogoUrl ? (react.createElement(Logo/* default */.Z, { altLogoUrl: altLogoUrl, variant: "careAlt", clientLogoUrl: react.createElement(IconLogoHomepaylogo/* default */.Z, { height: "41px", width: "140px" }), sx: {
            alignItems: 'center',
        } })) : (react.createElement(Logo/* default */.Z, { clientLogoUrl: react.createElement(IconLogoHomepaylogo/* default */.Z, { height: "41px", width: "140px" }), sx: {
            alignItems: 'center',
        } })))));
};
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(70891);
;// CONCATENATED MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorHeader/components/HeaderLink.js


const HeaderLink = ({ link }) => {
    var _a;
    if (link.isVisible === false) {
        return null;
    }
    switch (link.type) {
        case 'text':
            return (react.createElement(Typography/* default */.Z, { className: link.className, variant: "body2" }, link.text));
        case 'button':
            return (react.createElement(Button/* default */.Z, { className: link.className, color: link.color, href: link.href, onClick: link.onClick, size: link.size, variant: link.variant }, link.text));
        case 'link':
        default:
            return (react.createElement(Link/* default */.Z, { sx: Object.assign({}, (link.bold && { fontWeight: 700 })), className: link.className, color: (_a = link.color) !== null && _a !== void 0 ? _a : 'text.primary', variant: "link2", underline: "none", href: link.href, onClick: link.onClick }, link.text));
    }
};
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorHeader/components/HeaderLinks.js



const HeaderLinks = ({ display = 'flex', links }) => {
    const listStyle = { display };
    return (react.createElement(List/* default */.Z, { sx: [{ display: 'flex' }, { display }], style: listStyle }, links.map((link) => (react.createElement(ListItem/* default */.ZP, { sx: (theme) => ({
            justifyContent: 'center',
            width: 'auto',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        }), key: link.text },
        react.createElement(HeaderLink, { link: link }))))));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyTGlua3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Ib21lUGF5VmlzaXRvckhlYWRlci9jb21wb25lbnRzL0hlYWRlckxpbmtzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUMvQyxPQUFPLEtBQTRCLE1BQU0sT0FBTyxDQUFDO0FBRWpELE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQU83QyxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQXlCLENBQUMsRUFBRSxPQUFPLEdBQUcsTUFBTSxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUU7SUFDL0UsTUFBTSxTQUFTLEdBQWtCLEVBQUUsT0FBTyxFQUFFLENBQUM7SUFFN0MsT0FBTyxDQUNMLG9CQUFDLElBQUksSUFBQyxFQUFFLEVBQUUsQ0FBQyxFQUFFLE9BQU8sRUFBRSxNQUFNLEVBQUUsRUFBRSxFQUFFLE9BQU8sRUFBRSxDQUFDLEVBQUUsS0FBSyxFQUFFLFNBQVMsSUFDM0QsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsQ0FDbkIsb0JBQUMsUUFBUSxJQUNQLEVBQUUsRUFBRSxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQztZQUNkLGNBQWMsRUFBRSxRQUFRO1lBQ3hCLEtBQUssRUFBRSxNQUFNO1lBQ2IsV0FBVyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO1lBQzdCLFlBQVksRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztTQUMvQixDQUFDLEVBQ0YsR0FBRyxFQUFFLElBQUksQ0FBQyxJQUFJO1FBQ2Qsb0JBQUMsVUFBVSxJQUFDLElBQUksRUFBRSxJQUFJLEdBQUksQ0FDakIsQ0FDWixDQUFDLENBQ0csQ0FDUixDQUFDO0FBQ0osQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTGlzdCwgTGlzdEl0ZW0gfSBmcm9tICdAbXVpL21hdGVyaWFsJztcbmltcG9ydCBSZWFjdCwgeyBDU1NQcm9wZXJ0aWVzLCBGQyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IEhvbWVQYXlWaXNpdG9ySGVhZGVyTGluayB9IGZyb20gJy4uL3R5cGVzLmpzJztcbmltcG9ydCB7IEhlYWRlckxpbmsgfSBmcm9tICcuL0hlYWRlckxpbmsuanMnO1xuXG5pbnRlcmZhY2UgSGVhZGVyTGlua3NQcm9wcyB7XG4gIGRpc3BsYXk/OiBDU1NQcm9wZXJ0aWVzWydkaXNwbGF5J107XG4gIGxpbmtzOiBIb21lUGF5VmlzaXRvckhlYWRlckxpbmtbXTtcbn1cblxuZXhwb3J0IGNvbnN0IEhlYWRlckxpbmtzOiBGQzxIZWFkZXJMaW5rc1Byb3BzPiA9ICh7IGRpc3BsYXkgPSAnZmxleCcsIGxpbmtzIH0pID0+IHtcbiAgY29uc3QgbGlzdFN0eWxlOiBDU1NQcm9wZXJ0aWVzID0geyBkaXNwbGF5IH07XG5cbiAgcmV0dXJuIChcbiAgICA8TGlzdCBzeD17W3sgZGlzcGxheTogJ2ZsZXgnIH0sIHsgZGlzcGxheSB9XX0gc3R5bGU9e2xpc3RTdHlsZX0+XG4gICAgICB7bGlua3MubWFwKChsaW5rKSA9PiAoXG4gICAgICAgIDxMaXN0SXRlbVxuICAgICAgICAgIHN4PXsodGhlbWUpID0+ICh7XG4gICAgICAgICAgICBqdXN0aWZ5Q29udGVudDogJ2NlbnRlcicsXG4gICAgICAgICAgICB3aWR0aDogJ2F1dG8nLFxuICAgICAgICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcoMiksXG4gICAgICAgICAgICBwYWRkaW5nUmlnaHQ6IHRoZW1lLnNwYWNpbmcoMiksXG4gICAgICAgICAgfSl9XG4gICAgICAgICAga2V5PXtsaW5rLnRleHR9PlxuICAgICAgICAgIDxIZWFkZXJMaW5rIGxpbms9e2xpbmt9IC8+XG4gICAgICAgIDwvTGlzdEl0ZW0+XG4gICAgICApKX1cbiAgICA8L0xpc3Q+XG4gICk7XG59O1xuIl19
;// CONCATENATED MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorHeader/resources/utils.js
const AUTH_LOGOUT_URL = '/vis/auth/oidc/logout';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Ib21lUGF5VmlzaXRvckhlYWRlci9yZXNvdXJjZXMvdXRpbHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyx1QkFBdUIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBBVVRIX0xPR09VVF9VUkwgPSAnL3Zpcy9hdXRoL29pZGMvbG9nb3V0JztcbiJdfQ==
;// CONCATENATED MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorHeader/resources/defaultContent.js

const getAuthLinks = (isMobile, isLoggedIn, loginEvent, logoutEvent, name) => {
    const handleLogoutClick = () => {
        logoutEvent();
        const redirectUri = encodeURIComponent(`${window.location.origin}/homepay`);
        window.location.assign(`${AUTH_LOGOUT_URL}?returnUrl=${redirectUri}`);
    };
    const handleLoginClick = () => {
        loginEvent();
    };
    if (isLoggedIn && name) {
        return [
            {
                text: `Hi, ${name}`,
                type: 'text',
            },
            {
                href: '#',
                text: 'Log out',
                type: 'link',
                onClick: handleLogoutClick,
            },
        ];
    }
    if (isMobile) {
        return [
            {
                href: '#',
                variant: 'contained',
                color: 'secondary',
                text: 'Log in',
                type: 'button',
                onClick: handleLoginClick,
            },
        ];
    }
    return [
        {
            href: '#',
            text: 'Log in',
            type: 'link',
            onClick: handleLoginClick,
        },
    ];
};
const getLeftSideLinks = (isMobile) => {
    const leftSideLinks = [
        {
            text: 'Home',
            href: '/',
            type: 'link',
            isVisible: isMobile,
        },
        {
            text: 'Service & Pricing',
            href: '/homepay/product-and-pricing',
            type: 'link',
        },
        {
            text: 'Resource Center',
            href: '/hp/',
            type: 'link',
        },
        {
            text: 'For Caregivers',
            href: '/homepay/caregivers',
            type: 'link',
        },
        {
            text: 'For Partners',
            href: 'https://partnership.myhomepay.com',
            type: 'link',
        },
        {
            text: 'ProPortal',
            href: '/homepay/proportal',
            type: 'link',
        },
    ];
    return leftSideLinks;
};
const getRightSideLinks = (isMobile, isLoggedIn, loginEvent, logoutEvent, name) => {
    const rightSideLinks = [
        {
            text: '(888) 273-3356',
            href: 'tel:+18882733356',
            type: 'link',
        },
        ...getAuthLinks(isMobile, isLoggedIn, loginEvent, logoutEvent, name),
    ];
    return rightSideLinks;
};
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorHeader/HomePayVisitorHeader.js







/**
 * The HomePay Visitor header. This is used for all external / visitor facing Homepay MFE's.
 */
const HomePayVisitorHeader = ({ isMobile, branding, isLoggedIn, loginEvent, logoutEvent, name, altLogoUrl, leftLinks = getLeftSideLinks(isMobile), rightLinks = getRightSideLinks(isMobile, isLoggedIn, loginEvent, logoutEvent, name), hasNoGetStartedCTA = false, onGetStartedClick, }) => {
    const theme = (0,useTheme/* default */.Z)();
    const isCare24Theme = (0,useIsCare24Theme/* default */.Z)();
    const [isSideDrawerOpen, setIsSideDrawerOpen] = (0,react.useState)(false);
    const handleDrawerVisibility = (isVisible) => {
        setIsSideDrawerOpen(isVisible);
    };
    const GetStartedButton = (react.createElement(Button/* default */.Z, { sx: {
            marginLeft: { md: theme.spacing(2) },
        }, size: "small", variant: "contained", onClick: onGetStartedClick }, "Get Started"));
    return (react.createElement(Container/* default */.Z, { sx: {
            display: 'flex',
            background: `${theme.palette.common.white} none repeat scroll 0 0`,
            boxShadow: `0 2px 4px 0 ${theme.palette.grey[200]}`,
            position: 'fixed',
            height: {
                xs: theme.spacing(7), // 56
                md: theme.spacing(13), // 104
            },
        }, maxWidth: false },
        react.createElement(Box/* default */.Z, { sx: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            } }, isMobile ? (react.createElement(react.Fragment, null,
            react.createElement(Box/* default */.Z, { display: "flex" },
                react.createElement(Box/* default */.Z, { display: "flex", alignItems: "center", "data-testid": "header-drawer-button", onClick: () => handleDrawerVisibility(true), pr: theme.spacing(0.25), sx: { marginRight: theme.spacing(2) } }, isCare24Theme ? react.createElement(Icon24Menu/* default */.Z, null) : react.createElement(Icon24UtilityMenu/* default */.Z, null)),
                react.createElement(BrandLink, { branding: branding, altLogoUrl: altLogoUrl })),
            !hasNoGetStartedCTA && GetStartedButton,
            react.createElement(SideDrawer, { onClose: () => handleDrawerVisibility(false), open: isSideDrawerOpen, ModalProps: { BackdropProps: { 'aria-label': 'backdrop' } } },
                react.createElement(Box/* default */.Z, { alignItems: "center", "data-testid": "header-mobile-menu-open", display: "flex", flexDirection: "column", justifyContent: "flex-start", sx: { '& a[href ^= "tel:"]': { color: theme.palette.text.link } } },
                    react.createElement(HeaderLinks, { display: "block", links: leftLinks }),
                    react.createElement(HeaderLinks, { display: "block", links: rightLinks }))))) : (react.createElement(react.Fragment, null,
            react.createElement(Box/* default */.Z, { alignItems: "center", display: "flex" },
                react.createElement(BrandLink, { branding: branding, altLogoUrl: altLogoUrl }),
                react.createElement(HeaderLinks, { links: leftLinks })),
            react.createElement(Box/* default */.Z, { alignItems: "center", display: "flex", sx: { '& a[href ^= "tel:"]': { color: theme.palette.text.link } } },
                react.createElement(HeaderLinks, { links: rightLinks }),
                !hasNoGetStartedCTA && GetStartedButton))))));
};
/* harmony default export */ var HomePayVisitorHeader_HomePayVisitorHeader = (HomePayVisitorHeader);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 20074:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconLogoHomepaylogo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53219);
/* harmony import */ var _utils_svgIconProps_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38423);
/* harmony import */ var _utils_generateStyles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46662);




/**
 * IconLogoHomepaylogo SVG icon component
 */
function IconLogoHomepaylogo(props) {
    const { sx, className } = props;
    const composedClassName = `${className !== null && className !== void 0 ? className : ''} IconLogoHomepaylogo`.trim();
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ sx: [Object.assign({}, (0,_utils_generateStyles_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props)), ...(Array.isArray(sx) ? sx : [sx])], viewBox: "0 0 456.275 88.675" }, (0,_utils_svgIconProps_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Object.assign(Object.assign({}, props), { className: composedClassName }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#213f5f", d: "M194 18.375c-7.6 0-14.15 4.65-17.1 9.075-1.9-5.7-6.125-9.075-13.725-9.075s-14.15 4.65-16.25 7.6v-6.55h-13.1V69.05H146.7V35.7c2.125-2.725 5.05-5.9 10.35-5.9s7.4 3.15 7.4 7.8v31.25h13.1V35.275c1.9-2.525 5.05-5.7 10.35-5.7s7.4 3.15 7.4 7.8v31.25l-.025.025v.625h13.3v-35.9c0-10.15-6.975-15-14.575-15m-96.25-.85c-16.25 0-26.175 11.625-26.175 25.975S81.5 69.675 97.75 69.675c16.475 0 26.4-12.025 26.4-26.175S114 17.525 97.75 17.525m0 40.55c-8.025 0-12.475-6.55-12.675-14.575 0-7.6 4.65-14.35 12.675-14.35s12.675 6.525 12.675 14.35-4.65 14.575-12.675 14.575m259.475-40.1c-8.25 0-14.575 2.725-19.85 8.225l3.6 5.275C345.4 26.6 349 24.5 356.175 24.5s12.45 3.8 12.45 10.55v8.875c-4.025-4.65-8.05-6.75-16.475-6.75s-17.3 5.475-17.3 16.25S345.375 69.9 352.15 69.9s12.475-2.55 16.475-6.975v5.7l.025.025v.2h7.8v-34.2c0-12.025-10.975-16.675-19.225-16.675m11.4 40.1c-2.95 4-8.225 6.125-13.725 6.325-7.175 0-12.25-4.225-12.25-10.775S349.4 42.65 354.9 42.65s10.775 2.125 13.725 6.125zm-321.75-31.05h-32.3V0H0v68.425h14.575V39.7h32.3v28.925H61.65V.225H46.875zm260.1-26.8h-27.45V68.85h8.45V41.625h19c13.725 0 21.525-9.5 21.525-20.7s-7.8-20.7-21.525-20.7m-.85 33.55h-17.95V7.6h17.95c8.22 0 13.719 5.494 13.725 13.087-.006 7.594-5.704 13.088-13.725 13.088m103.05 25.775L392.7 18.8h-8.225l20.7 50.05-3.375 7.6c-1.7 4.225-4.025 5.275-7.4 5.275-1.275 0-3.175-.425-4.225-.85L388.9 88.05c1.475.425 4 .625 5.7.625 6.55-.2 11.625-2.95 14.575-10.125L434.1 18.8h-8.45zM243.85 17.75c-15.2 0-25.75 11.625-25.75 25.975 0 15.825 11.4 25.975 26.6 26.175 7.8 0 15.625-2.55 20.475-6.975l-5.7-8.45c-3.175 2.95-4.85 4.85-13.3 4.85s-13.5-5.075-14.35-11.4h36.95v-2.95c0-16.025-9.725-27.225-24.925-27.225M231.6 39.075c.65-4.85 4.225-10.975 12.25-10.975 8.65 0 11.825 6.325 12.25 10.975zm208-18.575c1.05 0 2.1.425 2.95 1.05l.85-1.05c-1.075-.85-1.475-1.275-3.6-1.275s-3.6 1.05-3.6 2.75 1.275 2.325 3.375 2.75c1.9.425 2.525.85 2.525 1.7s-.825 1.475-2.1 1.475-2.325-.425-3.375-1.275l-.85 1.05.025.025c1.25 1.05 2.1 1.475 4 1.475s3.6-1.275 3.6-2.75-1.275-2.325-3.375-2.75c-1.9-.425-2.525-.85-2.525-1.7s1.05-1.475 2.1-1.475m15.2-1.075-3.6 5.275-3.6-5.275h-1.475v9.7h1.275v-7.4L451 27h.2l3.6-5.275v7.4h1.475v-9.7z", "data-name": "Layer 1" })));
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 54506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_head; }
});

// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_curry1.js
var _curry1 = __webpack_require__(94443);
// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_isString.js
var _isString = __webpack_require__(70795);
;// CONCATENATED MODULE: ./node_modules/ramda/es/internal/_nth.js

function _nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return (0,_isString/* default */.Z)(list) ? list.charAt(idx) : list[idx];
}
;// CONCATENATED MODULE: ./node_modules/ramda/es/head.js



/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String | Undefined
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> undefined
 */
var head = /*#__PURE__*/(0,_curry1/* default */.Z)(function (list) {
  return _nth(0, list);
});
/* harmony default export */ var es_head = (head);

/***/ }),

/***/ 70795:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _isString; }
/* harmony export */ });
function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

/***/ })

}]);